import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Dialog, {DialogProps} from '@mui/material/Dialog';

type AlertProps = DialogProps & {
  title?: string
}

export default function Alert({
  children,
  title = null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose = () => { },
  ...others
}: AlertProps) {
  const { t } = useTranslation(['main']);

  return (
    <Dialog
      onClose={onClose}
      {...others}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose as any} color="primary">
          {t('buttons.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
